import { ThirdPartyProvider } from '@shared/enums/third-party-provider.enum';
import { passkeyProviderContract } from './passkey.contract';
import { createStandardOAuthProviderContract } from './standard-oauth.contract';
import type { StandardThirdPartyProvider } from '@shared/models';
import type { ThirdPartyProviderContract } from './types';

const standardOAuthProviders: StandardThirdPartyProvider[] = [
  ThirdPartyProvider.Apple,
  ThirdPartyProvider.Google,
  ThirdPartyProvider.FaceBook,
  ThirdPartyProvider.Zalo,
  ThirdPartyProvider.Telegram,
  ThirdPartyProvider.WalletConnect,
];

const standardOAuthContracts = Object.fromEntries(
  standardOAuthProviders.map((provider) => [provider, createStandardOAuthProviderContract(provider)]),
) as Record<StandardThirdPartyProvider, ThirdPartyProviderContract>;

export const thirdPartyProviderContracts: Record<ThirdPartyProvider, ThirdPartyProviderContract> = {
  ...standardOAuthContracts,
  [ThirdPartyProvider.Passkey]: passkeyProviderContract,
};

export const resolveProviderFromParam = (providerParam: Nullable<string>): ThirdPartyProvider | undefined => {
  if (!providerParam) {
    return undefined;
  }

  return Object.values(ThirdPartyProvider).find((provider) => provider.toLowerCase() === providerParam.toLowerCase());
};

export const getProviderContract = (provider: Nullable<ThirdPartyProvider>): ThirdPartyProviderContract | undefined => {
  if (!provider) {
    return undefined;
  }

  return thirdPartyProviderContracts[provider];
};
